import React from 'react';
import { motion } from 'motion/react';

export function EmptyState({ title, description, actionLabel = 'Get Started', onAction }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col items-center justify-center py-24 px-8 text-center max-w-2xl mx-auto"
    >
      <div className="mb-8">
        <div className="w-1 h-24 bg-border mx-auto mb-8"></div>
      </div>
      
      <motion.h3
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="serif text-4xl text-foreground mb-6"
      >
        {title}
      </motion.h3>
      
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="text-muted-foreground leading-relaxed max-w-md"
      >
        {description}
      </motion.p>

      {onAction && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="mt-12"
        >
          <button
            onClick={onAction}
            className="px-8 py-3 border border-foreground text-foreground hover:bg-foreground hover:text-background transition-all duration-300 text-sm uppercase tracking-widest"
          >
            {actionLabel}
          </button>
        </motion.div>
      )}
    </motion.div>
  );
}

